module.exports = __webpack_public_path__ + "static/inventory-storage-87bc68b10524cd8b4264ce7f4e5f8961.png";